'use client';

import { useAtomValue } from 'jotai';
import { pdpParamsWithSyncAtom } from '@/atoms/pdpParamsAtom';
import { FavoriteButton } from '@/components/FavoriteButton/FavoriteButton';
import { getOneSizeId } from '@/utility/getOneSizeId';

type MobilePdpFavoriteButtonProps = {
  sellableId: string;
  compositionId: string;
  productTypeId: string;
  productType: ClientProductType;
  shopId: number;
  trackedPrice: number;
  label: string | undefined;
  initialAppearanceId: string;
};

export const MobilePdpFavoriteButton = ({
  sellableId,
  compositionId,
  productTypeId,
  productType,
  shopId,
  trackedPrice,
  label,
  initialAppearanceId,
}: MobilePdpFavoriteButtonProps) => {
  const pdpParams = useAtomValue(pdpParamsWithSyncAtom);
  const appearanceId = pdpParams?.appearanceId ?? initialAppearanceId;
  const sizeId = pdpParams?.sizeId ?? getOneSizeId(productType);

  return (
    <FavoriteButton
      className="absolute top-3 right-3 z-10 md:hidden"
      testId="pdp-favorite-button"
      variant="plain"
      sellableId={sellableId}
      compositionId={compositionId}
      productTypeId={productTypeId}
      appearanceId={appearanceId}
      sizeId={sizeId}
      shopId={shopId}
      price={trackedPrice}
      label={label}
    />
  );
};
